/**
 * In-app marketing campaign (login-only popup).
 *
 * Frontend-only — no API. Flip `PROMO_CAMPAIGN_ENABLED` to turn the popup
 * on or off for the whole app. Add slides here when a new campaign ships;
 * bump `version` so people who dismissed an older campaign see the new one.
 *
 * Opens once after a successful login. It must not open again on in-app
 * navigation (Daily Log / other forms live outside MainShell and remount it).
 */

/** Master switch. `false` = never show the popup. */
export const PROMO_CAMPAIGN_ENABLED = true;

export const PROMO_CAMPAIGN_STORAGE_KEY = "hrms:promo-campaign-dismissed";

/** sessionStorage: "pending" after login, "shown" after the popup opens this session. */
export const PROMO_CAMPAIGN_LOGIN_FLAG_KEY = "hrms:promo-campaign-login";

export const PROMO_CAMPAIGN = {
  id: "kornivus-referral",
  version: 2,
  ctaLabel: "Open referral program",
  ctaTo: "/referral",
  slides: [
    {
      id: "refer",
      kicker: "Partner with Kornivus",
      title: "Refer an agency. Earn $1,000.",
      body: "Introduce a home health or hospice team that still runs charts and visits on scattered tools. When they go live on Kornivus, you receive a $1,000 thank-you.",
      highlight: "$1,000 reward",
      image: "/promo/patient-visit.jpg",
      imageAlt: "Home health clinician visiting a patient at home",
    },
    {
      id: "how",
      kicker: "How it works",
      title: "You introduce. We onboard.",
      body: "Share the agency name and a contact. Our team handles the conversation. The reward is paid after they go live — nothing extra in your daily workflow.",
      highlight: "3 simple steps",
      image: "/promo/clinician-team.jpg",
      imageAlt: "Physician and clinician reviewing a patient care plan",
    },
    {
      id: "why",
      kicker: "Built for agencies",
      title: "Care, charts, and progress in one place",
      body: "Kornivus already runs your employees, patient charts, episodes, authorizations, and scheduling. Referring a peer is recommending the system you use every day.",
      highlight: "Patients · clinicians · operations",
      image: "/promo/care-progress.jpg",
      imageAlt: "Doctor and nurse supporting a patient in care",
    },
  ],
};
